import { countUp } from './facts'

export const initializeTabs = () => {
  const tabs = document.querySelectorAll('[data-component="tabs"]')

  tabs.forEach(tab => {
    const tabButtons = tab.querySelectorAll('[data-component="tab-button"]')
    const tabContents = tab.querySelectorAll('[data-component="tab-content"]')

    // Helper to trigger countup for all items in a container
    const triggerCountups = (container) => {
      const countEls = container.querySelectorAll('[data-countup]')
      countEls.forEach(el => countUp(el))
    }

    // Handle scroll-into-view for the initially active tab
    const activeContent = tab.querySelector('[data-component="tab-content"][data-active="true"]')
    if (activeContent) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            triggerCountups(entry.target)
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.1 })
      observer.observe(activeContent)
    }

    tabButtons.forEach(tabButton => {
      const tabindex = tabButton.dataset.tabindex

      tabButton.addEventListener('click', () => {
        tabContents.forEach(content => {
          content.dataset.active = String(content.dataset.tabindex === tabindex)
        })

        tabButtons.forEach(button => {
          button.dataset.active = String(button.dataset.tabindex === tabindex)
        })

        // Trigger countup when tab is opened
        const tabContent = tab.querySelector(
          `[data-component="tab-content"][data-tabindex="${tabindex}"]`
        )
        if (tabContent) {
          triggerCountups(tabContent)
        }
      })
    })
  })
}
